import { render, staticRenderFns } from "./BaseLoadingState.vue?vue&type=template&id=c459afba"
import script from "./BaseLoadingState.vue?vue&type=script&lang=js"
export * from "./BaseLoadingState.vue?vue&type=script&lang=js"
import style0 from "./BaseLoadingState.vue?vue&type=style&index=0&id=c459afba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports